import { DataRoomStatus } from 'further-types/data-room';
import { Realm } from 'further-types/global';
import { z } from 'zod';

export const GetDataRoomInput = z.object({
  id: z.string(),
});

export const CreateDataRoomInput = z.object({
  realm: z.nativeEnum(Realm),
  linkedToId: z.string(),
});

export const UpdateDataRoomBaseSchema = z.object({
  id: z.string(),
  subheading: z.string(),
  headline: z.string(),
  contact: z.object({
    name: z.string(),
    email: z.string(),
    phone: z.string(),
    image: z.object({ objectKey: z.string() }),
  }),
  keyInformation: z.array(
    z.object({
      id: z.string().optional(),
      fieldName: z.string(),
      value: z.string(),
    }),
  ),
  logoSettings: z
    .object({
      useCustomLogo: z.boolean().optional(),
      customLogo: z.object({ objectKey: z.string() }).optional(),
    })
    .optional(),
  legalTermsSettings: z
    .object({
      requirePreAccessAgreement: z.boolean().optional(),
      useSystemDefaultAgreement: z.boolean().optional(),
      customAgreementTitle: z.string().optional(),
      customAgreementContent: z.string().optional(),
    })
    .optional(),
  investmentOpportunitiesContent: z
    .object({
      title: z.string().optional(),
      subtitle: z.string().optional(),
      description: z.string().optional(),
      metrics: z
        .array(
          z.object({
            id: z.string().optional(),
            fieldName: z.string(),
            value: z.string(),
          }),
        )
        .optional(),
    })
    .optional(),
});

export const UpdateDataRoomLiveSchema = UpdateDataRoomBaseSchema.extend({
  status: z.literal(DataRoomStatus.Live),
  headline: z.string().trim().min(1, { message: 'Enter a headline.' }),
  contact: z.object({
    name: z.string().trim().min(1, { message: 'Enter a contact name.' }),
    email: z.string().trim().email({ message: 'Enter a valid contact email.' }),
    phone: z
      .string()
      .trim()
      .min(1, { message: 'Enter a contact phone number.' }),
    image: z.object({
      objectKey: z
        .string()
        .trim()
        .min(1, { message: 'Upload a contact image.' }),
    }),
  }),
  investmentOpportunitiesContent: z.object({
    title: z.string().trim().min(1, { message: 'Enter a title.' }),
    subtitle: z.string().trim().min(1, { message: 'Enter a subtitle.' }),
    description: z.string().trim().min(1, { message: 'Enter a description.' }),
    metrics: z
      .array(
        z.object({
          id: z.string().optional(),
          fieldName: z.string(),
          value: z.string(),
        }),
      )
      .optional(),
  }),
});

export const UpdateDataRoomInactiveSchema = UpdateDataRoomBaseSchema.extend({
  status: z.literal(DataRoomStatus.Inactive),
});

export const UpdateDataRoomInput = z.discriminatedUnion('status', [
  UpdateDataRoomLiveSchema,
  UpdateDataRoomInactiveSchema,
]);

export const SetDataRoomStatusInput = z.object({
  id: z.string(),
  statusToSet: z.nativeEnum(DataRoomStatus),
});
